<template>
    <el-dialog v-model="dialogVisible" :title="title" width="1000px" center>
        <div class="dialog-content-box">
            <div class="box-title">
                <div v-for="(item, index) in columnsNumber" :key="index">请选择{{ levelList[index] }}级选项</div>
            </div>
            <div class="split-line-row"></div>
            <div class="options-box">
                <div class="options-box-level" v-for="itemA in columnsNumber" :key="itemA">
                    <!-- 选项 -->
                    <div
                        v-for="(item, index) in selectList[itemA + '']"
                        @click="choseOptions(item, itemA + '', index + 1)"
                        :style="{
                            borderColor: isShowFocusStyle(itemA + '', index) ? 'rgba(0, 110, 255, 1.00)' : ' rgba(229, 232, 238, 1.00)',
                        }"
                        :key="index"
                        class="option-item"
                    >
                        <div contenteditable="true">{{ item.label }}</div>
                        <svg-icon v-if="isShowFocusStyle(itemA + '', index)" name="Subtract" class="svg-icon" />
                        <div v-if="isShowFocusStyle(itemA + '', index)" class="button-delete" @click.stop="deleteOptions(itemA + '', index)">-</div>
                    </div>
                    <div class="button-add" v-if="itemA == 1 || current[itemA - 1]" @click="addOptions(itemA + '')">
                        <svg-icon name="addOption" />添加选项
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmEdit">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, watch } from "vue";

const emits = defineEmits(["confirmOption"]);
const props = defineProps({
    title: {
        type: String,
        default: "编辑选项",
    },
    optionsList: {
        type: Object,
        default: {},
    },
    // 几级选项
    columnsNumber: {
        type: Number,
        default: 4,
    },
});
const levelList = ["一", "二", "三", "四"];
let questionC = ref({});
let dialogVisible = ref(false);
let choseIconIndex = ref("");
let selectList = ref({}); // 存储列表需要得数据
let current = ref({});
let columns = ref(0);
let columnsList = reactive([]);

watch(dialogVisible, () => {
    initData();
});

defineExpose({ dialogVisible });

const confirmEdit = async () => {
    await findcolums(questionC.value, 1);
    // 判断有几列数据
    emits("confirmOption", { data: questionC.value, columns: columns.value });
    dialogVisible.value = false;
};
// 是否展示边框颜色和箭头
const isShowFocusStyle = (key, index) => {
    return current.value[key] == index + 1;
};

// 初始化数据
function initData() {
    questionC.value = JSON.parse(JSON.stringify(props.optionsList));
    choseIconIndex.value = "1";
    selectList.value = {};
    selectList.value["1"] = questionC.value;
    current.value = {};
    columns.value = 0;
    columnsList = [];
    findDefaultOption(questionC.value, 1);
}

// 递归遍历数组,找到列数
function findcolums(data, level) {
    columns.value = level;
    data.forEach((item) => {
        if (item.children && item.children.length > 0) {
            columnsList.push(level + 1);
            findcolums(item.children, level + 1);
        } else {
            columnsList.push(level);
        }
    });
    console.log(columnsList);
    columns.value = columnsList.length > 0 ? Math.max(...columnsList) : 0;
}
// 递归，找到刚开弹框默认选中选项
function findDefaultOption(data, level) {
    for (let index = 1; index <= data.length; index++) {
        let item = data[index - 1];
        // 下一级别赋值
        selectList.value[level + 1 + ""] = item.children;
        if (item.children && item.children.length > 0) {
            // 当前级别选中值
            current.value[level + ""] = index + "";
            findDefaultOption(item.children, level + 1);
            break;
        }
    }
}
function choseOptions(item, key, index) {
    // key + 1为 下一个层级key值
    selectList.value[+key + 1] = item.children;
    // 当前层级选中值
    current.value[key] = index;
    // 判断当前选中是哪一栏得，大于下一栏得所有数据清空
    switch (key) {
        case "1":
            // 清空下一级后面级联数据
            selectList.value["3"] = [];
            selectList.value["4"] = [];
            // 清空后面选中数据
            current.value["2"] = "";
            current.value["3"] = "";
            current.value["4"] = "";
            break;
        case "2":
            // 清空下一级后面级联数据
            selectList.value["4"] = [];
            current.value["3"] = "";
            current.value["4"] = "";
            break;
        case "3":
            // 清空下一级后面级联数据
            current.value["4"] = "";
            break;
    }
}

// 最后一列点击选中
function choseOptions4(key, index) {
    current.value[key] = index;
}
// 选项新增
function addOptions(selectNum) {
    // questionC 级联数据新增
    // selectList 展示数据新增
    let list = selectList.value[selectNum];
    let obj = {
        label: `选项${list.length + 1}`,
        value: list.length + 1,
        children: [],
    };
    selectList.value[selectNum].push(obj);
}

// 选项删除
function deleteOptions(selectNum, index) {
    selectList.value[selectNum].splice(index, 1);
    switch (selectNum) {
        case "1":
            console.log(1);
            // 清空后面级联数据
            selectList.value["2"] = [];
            selectList.value["3"] = [];
            selectList.value["4"] = [];
            // 清空后面选中数据
            current.value["1"] = "";
            current.value["2"] = "";
            current.value["3"] = "";
            current.value["4"] = "";
            break;
        case "2":
            selectList.value["3"] = [];
            selectList.value["4"] = [];
            current.value["2"] = "";
            current.value["3"] = "";
            current.value["4"] = "";
            break;
        case "3":
            selectList.value["4"] = [];
            current.value["3"] = "";
            current.value["4"] = "";
            break;
        case "4":
            current.value["4"] = "";
            break;
    }
}
</script>
<style lang="scss" scoped>
//滚动条样式
::-webkit-scrollbar {
    width: 1px;
    border-radius: 2px;
    background-color: rgba(204, 204, 204, 0.1);
}
::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: rgba(204, 204, 204, 1);
}
.dialog-content-box {
    .box-title {
        display: flex;
        div {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: rgba(112, 120, 134, 1);
        }
    }
    .split-line-row {
        width: 100%;
        height: 1px;
        background: rgba(229, 232, 238, 1);
        margin: 5px 0 10px 0;
    }
    .options-box {
        display: flex;
        .options-box-level {
            display: flex;
            align-items: center;
            flex: 1;
            flex-direction: column;
            height: 300px;
            border-right: 1px solid rgba(229, 232, 238, 1);
            overflow: auto;
            padding-top: 7px;
            &:last-child {
                border-right: none;
            }
            .option-item {
                width: 209px;
                height: 29px;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(229, 232, 238, 1);
                padding: 3px 5px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(112, 120, 134, 1);
                margin-bottom: 11px;
                position: relative;
                div:focus-visible {
                    outline: none;
                    border-color: rgba(0, 110, 255, 1);
                }
                .svg-icon {
                    width: 4px;
                    height: 9px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translate(100%, -50%);
                }
            }
            .button-add {
                width: 209px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(34, 64, 195, 1);
                cursor: pointer;
            }
            .button-delete {
                position: absolute;
                top: 0;
                right: 0;
                transform: translate(50%, -50%);
                width: 13px;
                height: 13px;
                line-height: 8px;
                border-radius: 50%;
                background: rgba(251, 100, 100, 1);
                color: rgba(255, 255, 255, 1);
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                cursor: pointer;
            }
        }
    }
}
</style>
